export const URL = {
  dashboard: "/",
  appointments: "/appointments",
  earnings: "/earnings",
  tutorials: "/tutorials",
  login: "/login",
  profile: "/update-profile",
  password: "/change-password"
};
